import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import feather from "feather-icons";
import {HeaderService} from "../../../../../services/header/header.service";
import {DetailInventaireComponent} from "../detail-inventaire/detail-inventaire.component";

@Component({
  selector: 'app-all-inv',
  templateUrl: './all-inv.component.html',
  styleUrls: ['./all-inv.component.scss']
})
export class AllInvComponent  {



}
